var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"display-flex flex-wrap"},[_c('div',{staticClass:"flex-col-12 title-area"},[_vm._v(_vm._s(_vm.title))]),(_vm.description)?_c('div',{staticClass:"flex-col-12 description"},[_c('h3',[_vm._v(_vm._s(_vm.description))])]):_vm._e(),_c('div',{staticClass:"flex-col-12 input pt-1"},[_vm._t("input")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }